import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../../http';
import { getApiErrorMessage, toApiError } from '../utils';

export const useDeleteAvatarsFetilizer = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async ({ id, url }: { id: string; url: string }) => {
			try {
				await api.delete(`/products/fertilizer/deleteAvatarByUrl/${id}`, { params: { url } });
			} catch (error) {
				throw toApiError(error, 'Erro ao apagar avatar do fertilizante');
			}
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['fertilizers'] });
			queryClient.invalidateQueries({ queryKey: ['fertilizer'] });
		},
		onError: (error) =>
			console.error(
				'Erro ao apagar avatar do fertilizante:',
				getApiErrorMessage(error, 'Erro ao apagar avatar do fertilizante')
			),
	});
};
